import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { API_ENDPOINT } from "../../../../services/api/resources";
import DataTable from "../../../../components/common/DataTable/DataTable";
import HeaderTitle from "../../../../components/common/HeaderTitle/HeaderTitle";
import { useSelector } from "react-redux";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const VendorInvoiceTable = () => {
  const [invoiceData, setInvoiceData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const Data = useSelector((state) => state.loginData.value);
  // const org_token = Data?.organization_token;
  const user_token = Data?.user?.token || Data?.user_token;

  const paginatedData = invoiceData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const totalPages = Math.ceil(invoiceData.length / rowsPerPage);

  useEffect(() => {
    axios
      .post(API_ENDPOINT.monthly_invoice_summary, { org_token: user_token })
      .then((res) => {
        console.log("API RESPONSE:", res.data);

        // Correct array extraction
        const apiData = Array.isArray(res.data.data) ? res.data.data : [];

        const formattedData = apiData.map((row) => {
          const formattedRow = { ...row };

          Object.keys(formattedRow).forEach((key) => {
            if (
              key.toLowerCase().includes("jan") ||
              key.toLowerCase().includes("feb") ||
              key.toLowerCase().includes("mar") ||
              key.toLowerCase().includes("apr") ||
              key.toLowerCase().includes("may") ||
              key.toLowerCase().includes("jun") ||
              key.toLowerCase().includes("jul") ||
              key.toLowerCase().includes("aug") ||
              key.toLowerCase().includes("sep") ||
              key.toLowerCase().includes("oct") ||
              key.toLowerCase().includes("nov") ||
              key.toLowerCase().includes("dec") ||
              key.toLowerCase().includes("total")
            ) {
              const value = formattedRow[key];
              if (!isNaN(value) && value !== null) {
                formattedRow[key] = Number(value).toLocaleString("en-IN");
              }
            }
          });

          return formattedRow;
        });

        setInvoiceData(formattedData);
      });
  }, []);

  const currentYear = new Date().getFullYear();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const tableHeaders = [
    "Merchant Name",
    ...months.map((month) => `${month} (${currentYear})`),
    `Total YTD (${currentYear})`,
  ];

  const Tableheadings = tableHeaders.map((header) => ({
    label: header,
    field: header.replace(/\s+/g, "_").toLowerCase().replace(/[()]/g, ""),
  }));

  return (
    <div style={{ margin: "auto", padding: "1rem" }}>
      <div style={{ overflowX: "auto", marginBottom: "2rem" }}>
        <div>
          <HeaderTitle titleText={"Payment Processed"} />
        </div>

        <DataTable
          headings={Tableheadings}
          tableData={paginatedData}
          actions={false}
          tableSize={paginatedData?.length === 0 ? "100%" : "100%"}
          viewBtn={false}
          sorting={true}
          editBtn={false}
          deleteBtn={false}
        />

        <div style={{ textAlign: "right", marginTop: "1rem" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            style={{ marginRight: 10 }}
          >
            Prev
          </button>
          Page {currentPage} of {totalPages}
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            style={{ marginLeft: 10 }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorInvoiceTable;
